import { atomFamily } from "recoil"

export const informationRequestIdStateFamily = atomFamily({
  key: "atoms/settings/informationRequestIdStateFamily",
  default: 0,
})
